import { TopoConnection } from "../Topology/TopoConnection";
import { TopoNode } from "../Topology/TopoNode";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";

export class TopoLinkMember {
	public LocalConnection: TopoConnection;
	public RemoteConnection: TopoConnection;

	constructor(localConnection: TopoConnection, remoteConnection: TopoConnection) {
		this.LocalConnection = localConnection;
		this.RemoteConnection = remoteConnection;
	}

	public NodeConnection(node: TopoNode): TopoConnection {
		if (this.HasLocalConnection && ObjUtils.Equals(this.LocalConnection.Node, node))
			return this.LocalConnection;
		else if (this.HasRemoteConnection && ObjUtils.Equals(this.RemoteConnection.Node, node))
			return this.RemoteConnection;
		else
			return null;
	}

	public get HasLocalConnection(): boolean {
		return !!this.LocalConnection;
	}

	public get HasRemoteConnection(): boolean {
		return !!this.RemoteConnection;
	}
}
